import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { Nacionalidad } from '../../models/nacionalidad/nacionalidad';

@Injectable({
  providedIn: 'root',
})
export class NacionalidadesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.NACIONALIDADES}`;
  constructor(private http: HttpClient) {}

  getNacionalidades(): Observable<Nacionalidad[]> {
    return this.http.get<Nacionalidad[]>(this.apiUrl);
  }
}
